import PagingModel from '@Apps/Search/Src/Models/PagingModel';
import { FilterModel } from '@Apps/Search/Src/Models/FilterModel';

export default class SearchModel {


    filter = new FilterModel();

    paging = new PagingModel();

    totalCount = 0;
}